import template from './BuilderRules.html';
import { BuilderRulesController } from './BuilderRulesController';
export const BuilderRulesComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: BuilderRulesController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        data: '<',
        application: '<',
        elementId: '@?',
        changeMode: '&?',
        queueName: '@?',
        queueId: '@?',
    },
};
